export default {
    methods: {
        getAddressFullText(address) {
            return [
                address.street,
                address.city,
                address.state,
                address.zip
            ].join(",");
        },
        getFormattedAddress(address) {
            return (
                "" +
                address.street +
                "<br>" +
                address.city +
                ", " +
                address.state +
                " " +
                address.zip
            );
        }
    }
};
